import React from 'react'
import { Helmet } from 'react-helmet';
import logo from '../images/LOGO marketBiz-02.png'
import logoWs from '../images/LANDING-PAGE-marketBiz_11.jpg'
import logoInsta from '../images/LANDING-PAGE-marketBiz_10.jpg'
import logoFace from '../images/LANDING-PAGE-marketBiz_09.jpg'
import imageEmail from '../images/9069152_email_push_icon.png'
import politPriv from '../documents/eba.pdf'

function MenuContacto() {

  const containerStyle = {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '5px',
      margin: '10px 0',
      flexWrap: 'wrap', // Allow wrapping
  };
    return (
        <div className="content">
          <Helmet>
            <title>Contacto - MarketBiz.ai</title>
            <meta
              name="description"
              content="Contáctanos si tienes dudas o problemas con MarketBiz.ai. Nuestro equipo de soporte está listo para ayudarte con tus necesidades."
            />
            <link rel="canonical" href="https://www.marketbiz.ai/Contacto" />
          </Helmet>
          <h1>Contacto</h1>

          <button className="large-button-contact" 
            style={{ fontSize: '1.8rem'}}
            onClick={() => window.location.href = 'mailto:d.vargas@marketbiz.ai' 
            }>
            CONTÁCTANOS
            <img 
              src={imageEmail}
              alt="Icono email" 
              className="button-icon" 
            />
          </button>
          <p></p>

          <div className="three-column-container" style={containerStyle}>
            <p className="column">www.marketBiz.ai</p>
            <p className="column">+57(322)7351427</p>
            <p className="column">d.vargas@marketBiz.ai</p>
          </div>
          <p></p>
          <img src={logo} alt="Logo marketBiz" className='responsive-image'/>
          <p style={{ fontSize: '0.8rem', fontWeight: 'normal', margin: 15, color: 'grey' }}>Copyrigthed © 2024 Colombia - EE.UU</p>
          <div className="three-column-container">
            <div className="column"></div>
            <div className="column">
              <div className="three-column-container">
                <div className="column">
                  <a href="https://www.facebook.com/share/qWrWMLdh3SrShSP9/?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer">
                    <img src={logoFace} alt='logo Facebook'/>
                  </a>
                </div>
                <div className="column">
                  <a href="https://www.instagram.com/market_biz_ai" target="_blank" rel="noopener noreferrer">
                    <img src={logoInsta} alt='logo Instagram'/>
                  </a>
                </div>
                <div className="column">
                  <a href="https://api.whatsapp.com/send?phone=573227351427" target="_blank" rel="noopener noreferrer">
                    <img src={logoWs} alt='logo whattsapp'/>
                  </a>
                </div>
              </div>
            </div>
            <div className="column"></div>
          </div>
          <a 
            href={politPriv} 
            target="_blank" 
            rel="noopener noreferrer"
            className="privacy-link"
          >
            Política de Privacidad
          </a>
        </div>
    );
}

export default MenuContacto;